export const locale = {
    lang: 'en',
    data: {
        "Acc_Lbl_BasicInformation": "Basic Information",
        "Acc_Lbl_FirstName": "First Name",
        "Acc_Val_FirstNameReq": "First name is required.",
        "Acc_Val_LastNameReq": "Last name is required.",
        "Acc_Val_NameInvalidChars": "First and last names can only use letters, hyphens, apostrophes, and accented characters. Please remove special characters and try again.",
        "Acc_Lbl_LastName": "Last Name",
        "Acc_Val_Email": "Email must be a valid email address.",
        "Acc_Placeholder_Email": "you@yourdomain.com",
        "Acc_Placeholder_Name": "e.g.",
        "Acc_Lbl_Work Email": "Work Email",
        "Acc_Head_Ph.No": "Phone Numbers",
        "Acc_War_Ph.No": "You have no phone numbers affiliated with this account. Please consider adding one.",
        "Acc_SMS_Display_Message": "The phone is used for Multi‑Factor Authentication (MFA), with text as the default verification method.",
        "Acc_Val_Ph.No": "Phone must be a valid phone #.",
        "Acc_War_NotVerified": "Not Verified",
        "Acc_War_Verified": "Verified",
        "Acc_Btn_VeriyByText": "Verify By Text",
        "Acc_War_InProgress": "In Progress",
        "Acc_War_StopRecieved": "Stop Received",
        "Acc_Hover_NotVerified": "Not Verified: You must verify your number by text before this number can be used to receive notifications.",
        "Acc_Btn_AddPh.No": "Add Phone Number",
        "Mobile": "Mobile",
        "Work": "Work",
        "Home": "Home",
        "Acc_Error_Verification": "There was a problem retrieving your account settings.",
        "Acc_Not_Ph.NoSMS": "A request to verify your phone number was sent as a text message.",
        "Acc_Not_Ph.NoCall": "A request to verify your phone number was sent as a phone call.",
        "Acc_Error_Ph.NoSMS": "Unable to initiate the verification text message.",
        "Acc_Error_Ph.NoCall": "Unable to initiate the verification phone call.",
        "Acc_Success_Ph.No": "Verification request sent",
        "Acc_Verification_InProgress": "In Progress: The verification has been sent as a text message and the system is waiting for the reply.",
        "Acc_Verification_Verified": "Verified: You may now enable texting and receive notifications on this number.",
        "Acc_STOPMessage": "Stop Received: The recipient of the notification has replied with a STOP message; therefore, the phone remains unverified.",
        "Acc_Verification_NotVerified": "Not Verified: You must verify your number by text before this number can be used to receive notifications.",
        "Acc_Success_Message": "Your account settings were saved.",
        "Acc_Error_Save" : "There was a problem saving your account settings.",
        "Acc_Language":"Language",
        "Acc_Lbl_PendingEmail": "Pending Email Address",
        "Acc_Error_CancelPendingEmail" : "There was a problem cancelling your pending email address.",
        "Secure_MFA_Header": "Multi-Factor Authentication (MFA)",
        "Secure_MFA_Description": "MFA prevents unauthorized access to your account by requiring you to enter a verification code when requested",
        "Secure_MFA_Enable": "MFA Enabled",
        "Secure_MFA_Disable": "MFA Disabled",
        "Secure_Choose_MFA_Method": "Choose your preferred method of MFA:",
        "Secure_Authentication_App_Lbl": "Authenticator App (Most Secure, Recommended)",
        "Secure_Phn_Verification_lbl": "Phone Verification",
        "Secure_Email_Verification_lbl": "Email Verification",
        "Secure_Single_Sign_lbl": "Single Sign On",
        "Secure_Enable_Single_Sign_lbl": "You may enable Single Sign On using your company's account.",
        "Secure_lbl_Enable": "Enable",
        "Secure_Single_Sign_Enabled_lbl": "Single Sign On has been enabled for this account with the following email address:",
        "Secure_lbl_Disable": "Disable",
        "Secure_Single_Sign_Error_lbl": "There was an error during your Single Sign On request. Please try again or reach out to your company administrator.",
        "Secure_Automatic_Signout_Header": "Automatic Sign Out",
        "Secure_Automatic_Signout_Description": "Automatically sign me out when I've been inactive for:",
        "Secure_Hour_lbl": "Hour",
        "Secure_Minute_lbl": "Minute",
        "Secure_Timedout_Description": "Paycor recommends a 20 minute automatic sign out; this setting does not apply to Paycor Payroll. This setting will take effect the next time you sign in.",
        
        "Action_Lbl_MyAction": "My Actions",
        "Action_Not_SSOProvider": "Your credentials are managed through your Single Sign-On (SSO) provider.",
        "Action_Lnk_ChangePass": "Change Your Password",
        "Action_Lnk_ChangeQue": "Change Your Security Questions",
        "Action_Lnk_ChangeUsername": "Change other usernames for a Single Sign-On Experience",
        "Action_Lnk_MergePaycorAccounts": "Merge your Paycor Accounts",
        "Action_Lnk_LinkToToD": "Link your Time On Demand Accounts",
        "Action_Lnk_DeveloperPortal": "Go Back",
        "Notification_Setting_Display_Message":"Please select how you would like to receive each individual notification.",
        "Notification_Text":"Notifications",
        "Block_MySettings":"This page is not supported during Impersonation.",

        "Google_Auth_QR_Description1": "Visit your mobile device's app store, search for \"authenticator\" and download an app of your choice. (Google Authenticator, Microsoft Authenticator, and Authy are popular and easy-to-use)",
        "Google_Auth_QR_Description2": "Use the app to scan this QR code, which will synchronize the codes it provides with your Perform account:",
        "Google_Auth_QR_Scan_Trouble_Linklbl": "Having trouble scanning?",
        "Google_Auth_Code_Description": "Having trouble scanning the barcode? You may enter this key along with your email into your authenticator app on your device.",
        "Google_Auth_Code_Step1": "Enter your email and the following code into your authenticator app.",
        "Google_Auth_Code_Step2": "Press continue and confirm the 6 digit code generated from your device.",
        "Google_Auth_QR_Scan_Linklbl": "Try and scan the QR code again",
        "Google_Auth_Verify_Code_Description1": "You'll receive a 6-digit code when your account has been successfully linked. Enter that code below to complete Google Authentication setup.",
        "Google_Auth_Verify_Code_Description2": "Next time you login, you'll be prompted for a code.",
        "Google_Auth_Verify_Code_lbl": "6-Digit Authenticator Code",
        "Google_Auth_Verify_Code_Placeholder": "Enter Code",
        "Google_Auth_Invalid_Code_Error": "Invalid Authentication Code",
        "Google_Auth_Setup_Header": "Setup Authenticator",
        "Google_Auth_QR_Retrieve_Error_Msg": "There was an error retrieving QR code.",
        "Google_Auth_Code_Validating_Error_Msg": "There was an error validating code.",
        "Google_Auth_Code_Validating_Header": "Confirm Authenticator Code",

        "Secure_MFA_Atleast_Two_Options_Select_Error": "At least two MFA options must be selected",
        "Secure_MFA_Data_Retrieving_Error": "There was a problem retrieving your mfa security settings.",
        "Secure_MFA_Data_Saved_Msg": "Your MFA settings were saved.",
        "Secure_MFA_Data_Save_Error_Msg": "There was a problem saving your MFA settings.",
        "Secure_SecureSetting_Data_Retrieving_Error": "There was a problem retrieving your security settings.",
        "Secure_SecureSetting_Data_Saved_Msg": "Your security settings were saved.",
        "Secure_SecureSetting_Data_Save_Error_Msg": "There was a problem saving your security settings.",
        "Notification_TextSMS":"Text(SMS)",
        "Notification_MobileApp":"Mobile App",
        "Notification_Inapp":"In-app",
        "Notification_Email":"Email",
        "Notification_Save_Message":"Notification preferences saved.",
        "Notification_Success":"Success!",
        "Notification_Error_Message":"There was a problem saving your notification preferences.",
        "Notification_Error":"Error!",



        // common  key value pairs that can be used in all pages can add inside this
        "Common": {
            "Save": "Save",
            "Cancel": "Cancel",
            "Error": "An error occurred.",
            "PleaseWait": "Please wait...",
            "ErrorSummary": "Error!",
            "Success": "Success",
            "Continue": "Continue",
            "Verify": "Verify",
        },
        // End
        // title key value pair can be added
        "Title": {
            "MySettings": "My Settings",
            "Account": "Account",
            "Security": "Security",
            "Notification_Preferences":"Notification Preferences"
        }
        //End
    }
};


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/my-settings/shared/assets/i18n/en.ts